import React from "react";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";
import Folder from "./Folder";

type AppProps = {
  type?: string;
  flag?: boolean;
  setFlag?: (data: boolean) => void;
  showDeleteIcon?: boolean;
  folder?: childFolderType;
  folderId?: number;
  client_code?: string | number | null;
  history?: any;
  company_name?: string;
  viewMoreFolderId?: number | null | undefined;
  showViewMore: boolean;
  handleToggleViewMore?: () => void;
  handleSetViewMoreFolderId?: (folder_id: number | null | undefined) => void;
  handleSetRenameModalData?: (folderData: childFolderType) => void;
  handleDeleteFileAndFolder?: (folderData: childFolderType) => void;
  toggleRenameFolderModal?: () => void;
  isRenameFolderPresent?: boolean;
  setSingleFolderData?: any;
  singleFolderData?: any;
  persistFolderData?: any;
  setPersistFolderData?: any;
  setCheckingBack?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowViewMore: React.Dispatch<React.SetStateAction<boolean>>;
  setShowViewMoreFiles: React.Dispatch<React.SetStateAction<boolean>>;
  checkingBack?: boolean;
  setSearchData?: React.Dispatch<React.SetStateAction<string>>;
  setShowSearchData?: React.Dispatch<React.SetStateAction<string>>;
  isFileAndFolderDelete?: boolean;
  childFolders: any;
  isParrentHide:number|null;
  handleHideFileFolder?:(data:childFolderType)=>void;
  handleUnHideFileFolder?:(data:childFolderType)=>void;
  isHideAndShowFileFolderPresent?:boolean;
};
const FolderMap = React.memo(
  ({
    client_code,
    isParrentHide,
    company_name,
    showViewMore,
    handleToggleViewMore,
    handleSetViewMoreFolderId,
    viewMoreFolderId,
    handleSetRenameModalData,
    toggleRenameFolderModal,
    isRenameFolderPresent,
    setSearchData,
    setShowSearchData,
    childFolders,
    setShowViewMore,
    setShowViewMoreFiles,
    handleDeleteFileAndFolder,
    isFileAndFolderDelete,
    handleHideFileFolder,
    handleUnHideFileFolder,
    isHideAndShowFileFolderPresent
  }: AppProps) => {
    const showFolderData = () => {
      let finalDocumentList =
        childFolders?.length > 0 &&
        childFolders.map((childFolder: any) => {
          
          return (
            <Folder
              key={childFolder.id}
              isParrentHide={isParrentHide}
              folder={childFolder}
              client_code={client_code}
              company_name={company_name}
              viewMoreFolderId={viewMoreFolderId}
              handleToggleViewMore={handleToggleViewMore}
              handleSetViewMoreFolderId={handleSetViewMoreFolderId}
              showViewMore={showViewMore}
              handleSetRenameModalData={handleSetRenameModalData}
              toggleRenameFolderModal={toggleRenameFolderModal}
              isRenameFolderPresent={isRenameFolderPresent}
              setSearchData={setSearchData}
              setShowSearchData={setShowSearchData}
              setShowViewMore={setShowViewMore}
              setShowViewMoreFiles={setShowViewMoreFiles}
              handleDeleteFileAndFolder={handleDeleteFileAndFolder}
              isFileAndFolderDelete={isFileAndFolderDelete}
              handleHideFileFolder={handleHideFileFolder}
              handleUnHideFileFolder={handleUnHideFileFolder}
              isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}
            />
          );
        });

      return finalDocumentList;
    };
    return <>{showFolderData()}</>;
  }
);

export default FolderMap;
